import api from '../utils/api';
import DispatchConstants from '../constants/DispatchConstants';
import EmailVerification from '../model/EmailVerification';

const EmailVerificationActions = {
  getUnverifiedEmailFeedListings(limit) {
    const data = {};

    if (limit) {
      data.limit = limit;
    }

    return (dispatch) =>
      dispatch(api.users.emailVerification.unverifiedEmailFeedListings(data)).then((response) => {
        if (response.success && response.response) {
          const emailVerificationModel = EmailVerification(response.response);

          dispatch(EmailVerificationActions.updateEmailVerificationInfo(emailVerificationModel));
          return emailVerificationModel;
        }
        return Promise.reject(response.error);
      });
  },
  updateEmailVerificationInfo(data) {
    return (dispatch) =>
      dispatch({
        type: DispatchConstants.UPDATE_EMAIL_VERIFICATION,
        payload: data,
      });
  },
};

export default EmailVerificationActions;
